export default __webpack_public_path__ + "static/top-49ebaae7de238462008cb5492ea67cc5.jpg";